import { render } from "./DataRuang.vue?vue&type=template&id=41d6b5d2"
import script from "./DataRuang.vue?vue&type=script&lang=js"
export * from "./DataRuang.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__